import { memo } from "react"
import { Link } from "react-router-dom";
import { getStartOfDayUnix, toMoneyFormat } from "utils";

const FinancialReport = props => {
    const { data } = props;
    const nowTimestamp = Math.floor(Date.now() / 1000);

    return (
        <div className="grid grid-cols-4 md:grid-cols-3 gap-4 mb-4">
            <div className="wrap-box tp-22 col-span-full md:col-span-1 relative transactions-hvr">
                <h3 className="title tp-34">امروز</h3>
                <span className="text-xs tp-35">لیست تراکنش های امروز</span>

                <div className="flex items-center justify-between mt-5">
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EFEEFA] text-[#6259CA] dark:bg-[#171634] hover:opacity-90">
                        <i className="fa-duotone fa-wallet"></i>
                    </div>

                    <b className="tp-9 text-lg">
                        {toMoneyFormat(data.data.wallet_since["1"].balance)} {" "}
                        <span className="text-xs font-normal">تومان</span>
                    </b>
                </div>

                <Link to={`/panel/transactions?created_at=${getStartOfDayUnix(nowTimestamp)}-`} className="pos-cover" />
            </div>

            <div className="wrap-box tp-22 col-span-2 md:col-span-1 relative transactions-hvr">
                <h3 className="title tp-34">7 روز گذشته</h3>
                <span className="text-xs tp-35">لیست تراکنش های 7 روز گذشته</span>

                <div className="flex items-center justify-between mt-5">
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EFEEFA] text-[#6259CA] dark:bg-[#171634] hover:opacity-90">
                        <i className="fa-duotone fa-wallet"></i>
                    </div>

                    <b className="tp-9 text-lg">
                        {toMoneyFormat(data.data.wallet_since["7"].balance)} {" "}
                        <span className="text-xs font-normal">تومان</span>
                    </b>
                </div>

                <Link to={`/panel/transactions?created_at=${getStartOfDayUnix(nowTimestamp - (86400 * 7))}-`} className="pos-cover" />
            </div>

            <div className="wrap-box tp-22 col-span-2 md:col-span-1 relative transactions-hvr">
                <h3 className="title tp-34">ماه گذشته</h3>
                <span className="text-xs tp-35">لیست تراکنش های 30 روز گذشته</span>

                <div className="flex items-center justify-between mt-5">
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EFEEFA] text-[#6259CA] dark:bg-[#171634] hover:opacity-90">
                        <i className="fa-duotone fa-wallet"></i>
                    </div>

                    <b className="tp-9 text-lg">
                        {toMoneyFormat(data.data.wallet_since["30"].balance)} {" "}
                        <span className="text-xs font-normal">تومان</span>
                    </b>
                </div>

                <Link to={`/panel/transactions?created_at=${getStartOfDayUnix(nowTimestamp - (86400 * 30))}-`} className="pos-cover" />
            </div>
        </div>
    )
}

export default memo(FinancialReport);